import { getMarketingTrackingData as getTMMarketingTrackingData } from '@ilg-totallymoney/cardloanutils'
import Cookies from 'js-cookie'

import { QueryParametersAppState } from './getAppStateFromQueryParameters'

/**
 * Get the tracking data by order of precedence:
 *
 * [1] Use the data from the query parameters
 * [2] Use the data from the cookies set by google tag manager
 *
 * @param appState - The app state generated from the query parameters
 * @returns The tracking data
 */
export const getMarketingTrackingData = <T extends string>(
    appState?: QueryParametersAppState
) => {
    return getTMMarketingTrackingData(
        appState as QueryParametersAppState,
        Cookies.get
    )
}
